import React from "react";
import { Link } from "react-router-dom";
import logoWhite from "../../assets/logo-white.png";
import { groupCategories } from "../../helper/categoryTree";

// `categories` is the flat category list; sub-categories are nested under their
// parent. Rendered with the template's own menu classes — `menu-item-has-children`
// / `sub-menu` / `second-lavel` (the theme's spelling) — so the trigger picks up
// the same font, colour and spacing as Home/About/Contact/Agency, and the theme's
// existing hover CSS opens both levels. No custom styling of our own.
const MobileMenu = ({ categories = [] }) => {
  const grouped = groupCategories(categories);
  return (
    <div id="mobilemenu-popup" className="offcanvas mobile-menu-wrap">
      <div className="mobile-logo-wrap d-lg-none d-block">
        <div className="logo-holder">
          <a
            href="index.html"
            className="link-wrap single-logo light-mode img-height-100"
            aria-label="Site Logo"
          >
            <img width="180" height="46" src={logoWhite} alt="logo" />
          </a>
          <a
            href="index.html"
            className="link-wrap single-logo dark-mode img-height-100"
            aria-label="Site Logo"
          >
            <img
              width="180"
              height="46"
              src="assets/media/logo-white.png"
              alt="logo"
            />
          </a>
        </div>
        <button
          aria-label="Offcanvas"
          type="button"
          className="mobile-close"
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-x-circle"></i>
        </button>
      </div>
      <nav id="dropdown" className="template-main-menu">
        <ul className="menu">
          <li className="menu-item">
            <Link to="/">Home</Link>
          </li>
          <li className="menu-item">
            <Link to="/about">About</Link>
          </li>
          {/* <li className="menu-item menu-item-has-children">
              <a href="#">Pages</a>
              <ul className="sub-menu">
                <li className="menu-item menu-item-has-children second-level">
                  <a href="#">Archive Pages</a>
                  <ul className="sub-menu">
                    <li className="menu-item"><a href="archive-layout1.html">Archive Layout 1</a></li>
                    <li className="menu-item"><a href="archive-layout2.html">Archive Layout 2</a></li>
                    <li className="menu-item"><a href="archive-layout5.html">Archive Layout 3</a></li>
                  </ul>
                </li>
                <li className="menu-item menu-item-has-children second-level">
                  <a href="#">Other Pages</a>
                  <ul className="sub-menu">
                    <li className="menu-item"><a href="author.html">Author</a></li>
                    <li className="menu-item"><a href="404.html">404</a></li>
                  </ul>
                </li>
              </ul>
            </li> */}
          {/* <li className="menu-item menu-item-has-children">
              <a href="#">Single Blog</a>
              <ul className="sub-menu">
                <li className="menu-item"><a href="post-format-default.html">Single Default</a></li>
                <li className="menu-item"><a href="post-format-full-width-banner.html">Single Full Width Banner</a></li>
                <li className="menu-item"><a href="post-format-without-sidebar.html">Single Without Sidebar</a></li>
              </ul>
            </li> */}
          <li className="menu-item">
            <Link to="/contact">Contact</Link>
          </li>

          <li className="menu-item">
            <Link to="https://agency.sarcasm.co/">Agency</Link>
          </li>

          {grouped.length > 0 && (
            <li className="menu-item menu-item-has-children menu-item-categories">
              {/* No href — there is no "all categories" page, this only opens
                  the submenu. tabIndex keeps it reachable by keyboard. */}
              <a tabIndex={0} style={{ cursor: "pointer" }}>
                Categories
              </a>
              <ul className="sub-menu">
                {grouped.map((cat) => (
                  <li
                    key={cat._id}
                    className={
                      cat.children.length
                        ? "menu-item menu-item-has-children second-lavel"
                        : "menu-item"
                    }
                  >
                    <Link to={`/categories/${cat?.slug}`}>{cat.name}</Link>
                    {cat.children.length > 0 && (
                      <ul className="sub-menu">
                        {cat.children.map((child) => (
                          <li className="menu-item" key={child._id}>
                            <Link to={`/categories/${child?.slug}`}>
                              {child.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default MobileMenu;
